/* eslint eqeqeq: "warn", no-plusplus: "warn" */
import Vue from 'vue';

Vue.component('member-autocomplete-component', {

    props: {
        playerIndex: {
            type: Number,
            required: true,
        },
        nameKey: {
            type: String,
            default: 'name',
        },
    },

    data() {
        return {
            playerSuggestions: [],
            playerName: '',
            playerId: '',
            activeIndex: 0,
        };
    },

    methods: {

        /**
         * Search on member first name & update the suggestions list.
         *
         * @return {Void}
         */
        updateSuggestions() {
            this.clearSuggestions();

            // Update search result if at least 3 chars.
            if (this.playerName.length >= 3) {
                this.$api.gms.member.searchMembers({ [this.nameKey]: this.playerName })
                .then((response) => {
                    this.playerSuggestions = response.data.result.members;
                })
                .catch((error) => {});
            }
        },

        /**
         * Clears the suggestions list.
         *
         * @return {Void}
         */
        clearSuggestions() {
            this.playerSuggestions = [];
        },

        /**
         * Triggers event passing on the current player index, the name and the member id.
         *
         * @return {Void}
         */
        triggerPlayerUpdate() {
            this.$emit('set-player', this.playerIndex, this.playerName, this.playerId);
        },

        /**
         * Handle a suggestion click event: Update player id and name and trigger player update event.
         *
         * @param  {String} playerId Player member id.
         * @param  {String} playerName
         * @return {Void}
         */
        onSuggestionClick(suggestionIndex) {
            this.setSuggestion(suggestionIndex);
        },

        /**
         * Update player id and name and trigger player update event.
         *
         * @param {Integer} suggestionIndex
         * @return {Void}
         */
        setSuggestion(suggestionIndex) {
            if (!this.playerSuggestions[suggestionIndex]) {
                return;
            }

            this.playerId = this.playerSuggestions[suggestionIndex].id;
            this.playerName = `${this.playerSuggestions[suggestionIndex].firstName} ${this.playerSuggestions[suggestionIndex].lastName}`;
            this.triggerPlayerUpdate();
        },

        /**
         * Handle field blur event: Clear suggestions with a small delay to allow a click event on a suggestion to fire still.
         *
         * @return {Void}
         */
        onFieldBlur() {
            setTimeout(() => {
                this.clearSuggestions();
            }, 300);
        },

        /**
         * Handle field focus event: update suggestions to show them again if any.
         *
         * @return {Void}
         */
        onFieldFocus() {
            this.updateSuggestions();
        },

        /**
         * Move to previous suggestion or wrap around the start or stay at 0 if there are no suggestions.
         *
         * @return {Void}
         */
        focusPreviousSuggestion() {
            if (this.activeIndex - 1 < 0) {
                if (this.playerSuggestions.length > 0) {
                    this.activeIndex = this.playerSuggestions.length - 1;
                    return;
                }
                this.activeIndex = 0;
                return;
            }
            this.activeIndex--;
        },

        /**
         * Move to next suggestion or wrap around the end or stay at 0 if there are no suggestions.
         *
         * @return {Void}
         */
        focusNextSuggestion() {
            if (this.activeIndex + 1 >= this.playerSuggestions.length) {
                this.activeIndex = 0;
                return;
            }
            this.activeIndex++;
        },

        /**
         * Handle keyup event on field, different actions on up/down arrows, return key or typing.
         *
         * @return {Void}
         */
        onFieldKeyup(event) {
            // Hitting return activates the current suggestion.
            if (event.keyCode == 13) {
                this.setSuggestion(this.activeIndex);
                return;
            }

            // Hitting the up arrow key moves up.
            if (event.keyCode == 38) {
                this.focusPreviousSuggestion();
                return;
            }

            // Hitting the down arrow key moves down.
            if (event.keyCode == 40) {
                this.focusNextSuggestion();
                return;
            }

            // Ignore irrelevant keys.
            // Note: http://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
            if (
                (event.keyCode < 48 && event.keyCode != 8) // any control keys except backspace
                || event.keyCode == 91 // left window key
                || event.keyCode == 92 // right window key
                || event.keyCode == 93 // select key
                || (event.keyCode >= 112 && event.keyCode <= 123) // f1 - f12
                || event.keyCode == 144 // num lock
                || event.keyCode == 145 // scroll lock
            ) return;

            this.handleTyping();
        },

        /**
         * Clear player id and trigger player update event, update search suggestions.
         *
         * @return {Void}
         */
        handleTyping() {
            this.playerId = '';
            this.triggerPlayerUpdate();
            this.updateSuggestions();
        },
    },
});
